






import { Component } from '@niknevis/vue-modules'
import { mixins } from 'vue-class-component'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import AdminCouponTitle from '@/modules/coupon/components/admin/AdminCouponTitle.vue'
import DiscountValue from '@/modules/shared/components/admin/discount-change/DiscountValue.vue'
import { CampaignStatus } from '@/modules/base-campaign/models/base-campaign-resource.model'
import ProfitValue from '@/modules/profit/components/admin/ProfitValue.vue'
import {
  AdminContentCampaignUpdateManualDiscountUseCase
} from '@/modules/content-campaign/use-cases/admin/admin-content-campaign-update-manual-discount.use-case'
import {
  AdminContentCampaignSaveProfitUseCase
} from '@/modules/content-campaign/use-cases/admin/admin-content-campaign-save-profit.use-case'

@Component({
  components: {
    TesTr
  }
})
export default class AdminContentCampaignFinancialTableRow extends mixins<TesTableRow>(TesTableRow) {
  constructor(
    private readonly discountUseCase: AdminContentCampaignUpdateManualDiscountUseCase,
    private readonly profitUseCase: AdminContentCampaignSaveProfitUseCase
  ) {
    super()
  }


  private columnComponents = {
    manual_discount: {
      component: DiscountValue,
      handler: (value, row) => ({
        class: 'justify-center',
        amount: value,
        editable: row.status === CampaignStatus.DRAFT,
        id: row.id,
        useCase: this.discountUseCase
      })
    },
    coupon: {
      component: AdminCouponTitle,
      handler: value => ({ couponResource: value })
    },
    profit: {
      component: ProfitValue,
      handler: (value, row) => ({
        class: 'justify-center',
        amount: value,
        editable: row.status !== CampaignStatus.DRAFT,
        useCase: this.profitUseCase,
        id: row.id
      })
    }
  }
}
